import script from "./ModalConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirm.vue?vue&type=style&index=0&id=d62ad5fc&scoped=true&lang=scss"

import exportComponent from "/workdir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d62ad5fc"]])

export default __exports__